import React from "react";
import { Button, Form, Input, message, Modal, Select, Space } from "antd";
import ClaimService from "../../../../services/ClaimService";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

interface Props {
  isVisible: boolean;
  onClose: () => void;
}

const ClaimModal: React.FC<Props> = ({ isVisible, onClose }) => {
  const handleConfirm = (values: any) => {
    Modal.confirm({
      title: "Confirmar envío",
      content: "¿Está seguro de que desea enviar este reclamo?",
      okText: "Sí, enviar",
      cancelText: "Cancelar",
      onOk: () => {
        ClaimService.claim({
          mail: values.email,
          userId: values.nombre,
          phone: values.Telefono,
          reason: values.motivo,
          description: values.descripcion,
        }).then((response) => {
          if (response) {
            message.success("Reclamo enviado con éxito");
            onClose();
          } else {
            message.error("Error al enviar el reclamo");
          }
        });
      },
    });
  };

  const onFinish = (values: any) => {
    handleConfirm(values);
  };

  return (
    <Form
      layout="vertical"
      initialValues={{ motivo: "otros" }}
      onFinish={onFinish}
    >
      <div className="row justify-content-evenly mx-2 mt-3">
        <div className="col-11 col-md-6">
          <Form.Item
            label={
              <p
                className="ms-2"
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                Código de cliente
              </p>
            }
            name="nombre"
            rules={[
              {
                required: true,
                message: "Por favor ingrese su Codigo de cliente",
              },
            ]}
            required={false}
            hasFeedback
          >
            <Input size="large" />
          </Form.Item>
        </div>
        <div className="col-11 col-md-6">
          <Form.Item
            label={
              <p
                className="ms-2"
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                Email
              </p>
            }
            name="email"
            rules={[
              { required: true, message: "Por favor ingrese su Email" },
              { type: "email", message: "El email no es válido" },
            ]}
            required={false}
            hasFeedback
          >
            <Input size="large" />
          </Form.Item>
        </div>
      </div>

      <div className="row justify-content-evenly mx-2 mt-3">
        <div className="col-11 col-md-6">
          <Form.Item
            label={
              <p
                className="ms-2"
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                Teléfono
              </p>
            }
            name="Telefono"
            rules={[
              {
                required: true,
                message: "Por favor ingrese su Telefono",
              },
            ]}
            required={false}
            hasFeedback
          >
            <Input size="large" />
          </Form.Item>
        </div>
        <div className="col-11 col-md-6">
          <Form.Item
            label={
              <p
                className="ms-2"
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                Motivo
              </p>
            }
            name="motivo"
            rules={[{ required: true, message: "Seleccione un Motivo" }]}
            required={false}
          >
            <Select size="large">
              <Select.Option value="faltanProductos" size="large">
                Faltan productos
              </Select.Option>
              <Select.Option value="productosIncorrectos" size="large">
                Productos incorrectos
              </Select.Option>
              <Select.Option value="problemasCalidad" size="large">
                Problemas de calidad
              </Select.Option>
              <Select.Option value="other" size="large">
                Otro
              </Select.Option>
            </Select>
          </Form.Item>
        </div>
        <div className="row">
          <div className="col-12 p-0">
            <Form.Item
              label={
                <p
                  className="ms-2"
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    margin: 0,
                  }}
                >
                  Descripción
                </p>
              }
              name="descripcion"
              rules={[{ required: true, message: "Describa el Problema" }]}
              required={false}
            >
              <TextArea rows={4} />
            </Form.Item>
          </div>
        </div>
        <div className="row my-3">
          <div className="col-12 col-md-3 p-0">
            <button
              style={{
                backgroundColor: "#006C36",
                border: "0px",
                color: "white",
                width: "100%",
                height: "40px",
                borderRadius: "8px",
                fontSize: "20px",
              }}
            >
              Enviar reclamo
            </button>
          </div>
        </div>
      </div>
    </Form>
  );
};
export default ClaimModal;
